import { Component, OnInit, ElementRef, ViewChildren, QueryList, EventEmitter, Output, Input, ChangeDetectorRef, OnChanges, SimpleChanges } from "@angular/core";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { getOSSListOfTimeZonesUsed, getProgramTimezoneIds } from "src/app/store/reselectors/programs.reselector";
import { ScrollLevel } from "src/app/store/programs.era";
import { takeUntil, debounceTime, repeat } from "rxjs/operators";
import { PROGRAM_TOP_SPACE, STANDARD_ACTIVITY_HEIGHT, POPIN_ACTIVITY_HEIGHT } from "./onsite.helpers-unchanged";
import { sleepForMS, saveLocal, loadLocal } from "../../helpers/helpers";
import { onsiteBuilderReselector, OnsiteView } from "src/app/store/reselectors/onsiteBuilder.reselector";
import { DAY_MS } from "src/app/helpers/constants";
import { JoiEvent, LabelMaps, makeEmptyLabelMaps } from "src/app/store/events.era";
import { ChangeScheduleDateDialogComponent } from "./onsite.dialog.changeScheduleDate.component";
import { DLLNode, OnsiteScheduleEntry, ProgramNodeDateMap, ProgramNode, OnsiteActivity, OnsiteSchedule, OnsiteLane, ManageActivityData } from 'globals/store/onsite.data';
import { activitiesReselector, ActivityReselectorData, onsiteReselector } from 'src/app/store/reselectors/onsite.reselector';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { ManageActivityComponent } from '../manage/manage-activity.component';
import { InputDialogData, InputDialogReturnData, InputDialogComponent } from 'src/app/components/wizards/input.dialog.component';
import { getYFromEstimatedHeightAndRect } from './../../helpers/helpers';
import { DropdownOption, TimeZoneDetails } from 'globals/store/programs.data';
import { VenueDialogData, VenueSelectDialogComponent } from "../program/venue-select.dialog.component";
import { Venue } from "globals/store/events.data";
import { Wrapper } from "src/app/components/wrapper.component";
import { fromEvent } from "rxjs";
import { Dictionary } from "@ngrx/entity";
import { CheckDialogComponent, OnlyChecksDialogData } from "../../components/wizards/checks.dialog.component";
import { MatMenuModule } from "@angular/material/menu";
import { IconComponent } from "src/app/components/icon/icon.component";
import { CommonModule, DatePipe } from "@angular/common";
import { LoaderPaneFragmentComponent } from "src/app/components/loader/loader-pane-fragment.component";
import { FindByPropPipe } from "src/app/services/pipes/findById.pipe";
import { JoiInputComponent } from "src/app/components/joi-input/joi-input.component";
import { MenuHoverButtonComponent } from "src/app/components/buttons/menu-hover-button.component";
import { ActivityBrickComponent } from "./activity-brick.component";
import { createId, date_id, str2Date } from "globals/helpers/helpers";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: 'onsite-builder',
    templateUrl: "./onsite.builder.html",
    styleUrls: ["./onsite.page.scss"],
    animations: [
        trigger("drop", [
            state("expand", style({ height: "*" })),
            state("collapse, undefined, void", style({ height: "0", padding: 0 })),
            transition("* => *", [animate("300ms")]),
            transition("void => *", [animate("0ms")])
        ]),
        trigger("slide", [
            state("expand", style({ width: "400px" })),
            state("collapse, undefined, void", style({ width: "0", border: 0 })),
            transition("* => *", [animate("300ms")]),
            transition("* => exiting", [animate("0ms")]),
        ])
    ],
    styles: [`
    :host { width: 100%; }
`],
    standalone: true,
    imports: [MatMenuModule, MatButtonModule, IconComponent, DatePipe, LoaderPaneFragmentComponent, CommonModule, FindByPropPipe, JoiInputComponent, MenuHoverButtonComponent, ActivityBrickComponent],
})
export class OnSiteBuilderComponent extends Wrapper<OnSiteBuilderComponent> implements OnInit, OnChanges {
  @Output() close: EventEmitter<null> = new EventEmitter();
  @Output() emitProgramDetail: EventEmitter<any> = new EventEmitter();
  @Output() emitSessionDetail: EventEmitter<any> = new EventEmitter();
  @Input() dateId: string;
  @Input() date: Date;
  @Input() readonly;
  @Input() hasDatesMenu = true
  hiddenSchedulesByDateId: Dictionary<Set<string>> = {}

  popupsDir = 0 // means don't show.  Needs to be set here with popupId for the least amount of delay possible ==>
  popupId = null // <== without glitchiness of showing the label over the popup

  POPIN_ACTIVITY_HEIGHT = POPIN_ACTIVITY_HEIGHT;
  transitioning = false
  activitiesData: Dictionary<ActivityReselectorData> = {}

  dateNodesByDate: Map<string, DLLNode<string>>;
  dateEntries: OnsiteScheduleEntry[][] = [];
  ossView: OnsiteView[]; // <== a single ossView, not all of them, now (old ossView[date_schedule.id])
  scheduleSlide = [];
  dontAutoScroll = true;
  traceNames = traceNames

  currentTick;
  @ViewChildren("programEl") programEl: QueryList<ElementRef>;
  @ViewChildren("scheduleEl") scheduleEl: QueryList<ElementRef>;
  scroll: ScrollLevel;
  currentViewSet = [];
  preset_time = "";
  hoverMinute = null;
  hoverView = null;
  currentEvent: JoiEvent = null;
  scrollFlags: any = {};
  subscriptionsHolder = [];
  labelMaps: LabelMaps = makeEmptyLabelMaps();
  programNodesByDate: ProgramNodeDateMap;
  programNodeCentersById: Map<String, ProgramNode>;
  listOfTimeZonesUsed:TimeZoneDetails[]
  timeZoneAbbrs:{[timeZoneId:string]:string} = {}
  programTimezoneIds: Set<string> = new Set()
  hiddenSchedules: Set<string> = new Set()
  readyId: string
  MAX_INITIAL_SCHEDULES = 5
  scheduleOptions: DropdownOption[]
  mobileScheduleId: string

  async editVisibleSchedules() {
    this.changeDetectorRef.detach()
    const checkboxes = this.ossView.map(v => ({
      title: v.lanes[0].title,
      checked: !this.hiddenSchedules.has(v.scheduleId),
      id: v.scheduleId
    }))
    const data: OnlyChecksDialogData = {
      title: 'Visible Onsite Schedules',
      checkboxes,
      instructions: 'Check to show a given schedule.',
      drag: false,
      atLeastOne: true,
      backgroundColor: '#FFD157'
    }
    await openDialogGetResult(this.dialog, CheckDialogComponent, { width: '360px', disableClose: true, data })
    this.hiddenSchedules = new Set(data.checkboxes.filter(c => !c.checked).map(c => c.id))
    saveLocal(`${this.eventService.eventId}/visibleOnsitePrograms/${this.dateId}`, Array.from(this.hiddenSchedules))
    this.hiddenSchedulesByDateId[this.dateId] = this.hiddenSchedules
    this.changeDetectorRef.reattach()
  }


  toggleShowSchedule(id: string) {
    if (this.hiddenSchedules.has(id)) this.hiddenSchedules.delete(id)
    else this.hiddenSchedules.add(id)
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log({changes, dateId: this.dateId, d: changes.dateId})
    if (changes.dateId ) {
      this.loadHidden()
    }
  }

  loadHidden() {
    console.log('loadHidden', this.dateId)
    this.readyId = this.dateId
    const localHiddenSchedule = loadLocal(`${this.eventService.eventId}/visibleOnsitePrograms/${this.dateId}`);    
    if (this.hiddenSchedulesByDateId[this.dateId]) this.hiddenSchedules = this.hiddenSchedulesByDateId[this.dateId]
    else if (localHiddenSchedule) this.hiddenSchedules = new Set(localHiddenSchedule);
    else if ((this.ossView?.length || 0) > this.MAX_INITIAL_SCHEDULES) this.hiddenSchedules = new Set(this.ossView.slice(this.MAX_INITIAL_SCHEDULES,).map(v => v.scheduleId))
    else this.hiddenSchedules = new Set()
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.subCallback(this.store.select(onsiteBuilderReselector), ({ ossView, scroll, ready }) => {
      console.log({ ossView, scroll, ready })
      this.scroll = scroll;
      this.ossView = ossView;
      if (this.ossView?.length) {
        this.scheduleOptions = this.ossView.map(v => ({ id: v.scheduleId, title: v.lanes[0]?.title || 'Untitled Schedule' }))
        if (!this.mobileScheduleId || !this.ossView.find(v => v.scheduleId === this.mobileScheduleId)) this.mobileScheduleId = this.ossView[0].scheduleId
      } else {
        this.scheduleOptions = []
      }
      this.scheduleOptions.push({ id: 'new', title: '+ Add a Schedule'})
      setTimeout(() => this.manualScroll(), 100);
      if (ready && this.readyId !== this.dateId) {
        this.loadHidden()
      }
    })
    this.selectProp(activitiesReselector, null, 'activitiesData')
    this.subProp(this.store.select("events", 'event'), 'currentEvent')
    this.subProp(this.store.select("events", 'labelMaps'), 'labelMaps')
    this.subCallback(this.store.select(onsiteReselector), ({ programNodesByDate, dateNodesByDate, programNodeCentersById, ready }) => {
        this.dateNodesByDate = dateNodesByDate;
        this.programNodesByDate = programNodesByDate;
        this.programNodeCentersById = programNodeCentersById;
      }
    )
    this.subCallback(this.store.select(getOSSListOfTimeZonesUsed), ({ listOfTimeZonesUsed, timeZoneAbbrs }) => {
      // console.log({ listOfTimeZonesUsed, timeZoneAbbrs })
      this.listOfTimeZonesUsed = listOfTimeZonesUsed || []
      this.timeZoneAbbrs = timeZoneAbbrs || {}
    })
    this.subProp(this.store.select(getProgramTimezoneIds), 'programTimezoneIds')
  }

  async addSchedule() {
    await sleepForMS(100)
    const last_order = this.ossView.length + 101;
    const new_id = createId();
    const { timeZoneId } = this.listOfTimeZonesUsed[0]
    const newStandalone: OnsiteSchedule = {
      id: new_id,
      scheduleId: new_id,
      title: 'Standalone Schedule',
      location: "",
      order: last_order,
      date: this.dateId,
      type: 'schedule',
      timeZoneId
    }
    this.mobileScheduleId = new_id
    this.activityService.addSchedule(newStandalone)
  }


  async openVenueManager(view: OnsiteView, lane: OnsiteLane, event: Event){
    const rect = (<HTMLElement>event.target).getBoundingClientRect()
    const position =  {top: rect.bottom + 5, left: rect.left < window.innerWidth - 300 ? rect.left : window.innerWidth - 302 }
    // console.log(rect, window.innerWidth)

    const data: VenueDialogData = {
      position,
      venues: Object.values(this.currentEvent.venues).filter(v=>!!v.googleId),
      selectedVenueId: view.venueId || null,
      type: 'Venue',
      closeOnChoice: true,
      dialogRef: null
    }
    // console.log({ rect, event, data })
    const returnData: { venue: Venue } = await openDialogGetResult(this.dialog, VenueSelectDialogComponent, { width: '300px', disableClose: true, data, backdropClass: 'clear' })
    if (!returnData) return
    this.activityService.changeStandaloneVenue(view.scheduleId, returnData.venue)
  }

  async updateStandAloneTimeZone(lane: OnsiteLane, timeZoneId) {
    this.activityService.changeStandaloneTimeZone(lane.laneId, timeZoneId)
  }

  manualScroll() {
    if (this.dontAutoScroll) {
      setTimeout(() => {
        this.dontAutoScroll = false
        this.commandScroll(this.dateId, this.scroll), 100
      })

    }
  }

  ngOnInit() {
    // console.log("!!! readonly ", this.readonly);
    
  }

  ngAfterViewInit(): void {
    this.scheduleEl.forEach(sch => this.hoverProcess(sch));
    this.scheduleEl.changes.subscribe(schedules => {
      schedules.forEach(sch => this.hoverProcess(sch))
    })
  }

  trackByFn(index) {
    return index;
  }

  trackByBrick(index, brick) {
    return brick.id
  }

  trackByScheduleId(index, view: OnsiteView) {
    return view.scheduleId
  }
  trackByLaneId(index, lane: OnsiteLane) {
    return lane.laneId
  }

  collapseOrExpandAll(act) {
    this.ossView.forEach(v => (this.scheduleSlide[v.scheduleId] = act));
  }

  changeDateId(direction: string) {
    let newDateId;
    if (direction === "prev") {
      newDateId = this.dateNodesByDate.get(this.dateId).prev.data;
    } else {
      newDateId = this.dateNodesByDate.get(this.dateId).next.data;
    }
    this.date = str2Date(newDateId)
    this.dontAutoScroll = true;
    this.router
      .navigate([
        "/event/onsite",
        "build",
        this.currentEvent.eventId,
        newDateId
      ])
      
  }
  async attachSchedule(view) {
    if(!this.currentEvent.can_access) return;
    await sleepForMS(100)
    const programNode = this.programNodeCentersById.get(view.scheduleId);
    const nSubschedules = programNode.subschedules.length
    const order = !nSubschedules ? 1 : programNode.subschedules[nSubschedules - 1].order + 1
    const newSchedule: OnsiteSchedule = {
      id: createId(),
      scheduleId: view.scheduleId,
      title: `${view.lanes[0]?.title || 'Unnamed '} Schedule`,
      order,
      type: 'SubSchedule',
    }
    this.activityService.addSchedule(newSchedule);
    this.preset_time = "";
    view.shake = { row: -1, position: 1000000 };
  }

  changeDate(lane) {
    // console.log(lane)
    const centerNode = this.programNodeCentersById.get(lane.parentId);
    const { date } = centerNode.schedule;
    const extension_days = centerNode.subschedules.map(sub => sub.day);
    // console.log({ extension_days })
    openDialogGetResult(this.dialog, ChangeScheduleDateDialogComponent, {
      width: "360px",
      disableClose: true,
      data: { schedule_date: date, extension_days }
    }).then((result: any) => {
      if (result && result.command === "change") {
        if (this.ossView.length === 1) {
          this.close.emit() // exit to date menu if there was only one schedule and its date was changed
        }
        this.activityService.changeStandaloneScheduleDate({
          standaloneId: lane.parentId,
          date: result.schedule_date
        })
      }
    })
  }

  async addDay(scheduleId: string, dateId: string, dateModification: number) {
    await sleepForMS(100)
    const programNode: ProgramNode = this.programNodesByDate[dateId].get(scheduleId)

    const extension = programNode.schedule.extension as number;
    const day = extension ? extension + dateModification : dateModification;
    const newSchedule: any = {
      id: createId(),
      scheduleId: programNode.schedule.scheduleId,
      day,
      extension: true
    };
    this.activityService.addSchedule(newSchedule).then(() => {
      this.router.navigate([
        "/event/onsite",
        "build",
        this.currentEvent.eventId,
        date_id(
          new Date(
            str2Date(this.dateId).getTime() +
            DAY_MS * dateModification
          )
        ) // navigate to new day
      ]);
    });
  }

  async addActivity(event: Event, schedule, day) {
    if (event) {
      event.stopPropagation();
    } else {
      return
    }

    const activity: OnsiteActivity = {
      id: createId(),
      linkId: schedule.laneId,
      createdBy: this.userService.email,
      day: day,
      labels: [],
      time: this.preset_time,
      title: '',
      extension: schedule.extension ? true : false,
      type: "activity"
    }
    await this.activityService.addActivity(activity)
    this.editActivity(activity, schedule)

  }

  async editActivity(activity, schedule) {
console.log({ activity, schedule })
    const data: ManageActivityData = {
      readOnly: this.readonly,
      activityId: activity.id,
      scheduleTitle: schedule.title,
      location: schedule.location,
      date: this.date
    }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageActivityComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()

  }

  saveTitle(view, title, lane) {
    if (lane.standalone) {
      this.activityService.changeStandaloneTitle({
        standaloneId: view.scheduleId,
        title
      });
    } else {
      this.activityService.changeSubscheduleTitle({
        programId: view.scheduleId,
        subscheduleId: lane.laneId,
        title
      });
    }
  }

  saveLocation(view, lane) {
    const { location, standalone } = lane;
    // console.log({ view, location, lane });
    if (!standalone) {
      // console.log(  "Saving location not implemented yet for non-standalone schedules" );
    } else {
      this.activityService.changeStandaloneLocation({
        standaloneId: view.scheduleId,
        location
      });
    }
  }

  private shouldExit(): boolean {
    const openPrograms = Array.from(this.programNodesByDate[this.dateId].values()).length
    console.log({ openNodes: openPrograms })
    return openPrograms === 1
  }

  public async deleteDateFromProgram(evt, lane, fromEl) {
    if (evt) evt.stopPropagation()

    const data = { 
      title: "Delete day from this program",
      para: "Deleting this day will remove all associated activities. This action cannot be undone.",
      rect: document.getElementsByClassName(fromEl)[0].getBoundingClientRect(),
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    // console.log({ evt, lane, fromEl })
    const shouldExit = this.shouldExit()
    await this.activityService.deleteExtensionDay(this.dateId, lane.laneId || lane.parentId)
    if (shouldExit) this.close.emit()
  }


  public async deleteStandaloneDate(evt, lane, fromEl, view) {
    if (evt) evt.stopPropagation();

    const data = { 
      title: "Delete day from this schedule",
      para: "Deleting this day will remove all associated activities. This action cannot be undone.",
      rect: document.getElementsByClassName(fromEl)[0].getBoundingClientRect(),
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    const shouldExit = this.shouldExit()
    await this.activityService.deleteExtensionDay(this.dateId, view.scheduleId)
    if (shouldExit) this.close.emit()
  }

  public async deleteSchedule(evt, lane, first, fromEl, view) {
    if (evt) evt.stopPropagation()
    // console.log({ scheduleSlide: this.scheduleSlide[view.scheduleId], lane })
    const scheduleType = first ? "schedule" : "sub-schedule"

    const data = { 
      title: `Delete this ${scheduleType}`,
      para: `Deleting this ${scheduleType} will remove all associated sub-schedules and activities. This action cannot be undone.`,
      rect: document.getElementsByClassName(fromEl)[0].getBoundingClientRect(),
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    if (lane.standalone) {
      // console.log("deleting standalone schedule", { lane });
      const shouldExit = this.shouldExit()
      await this.activityService.deleteStandaloneSchedule(view.scheduleId)
      if (shouldExit) this.close.emit()
    } else if (!first) {
      // console.log("deleting subschedule", { lane, first, view });
      this.scheduleSlide[lane.laneId] = 'exiting'
      this.activityService.deleteSubschedule({
        subscheduleId: lane.laneId,
        programId: view.scheduleId
      })
    }
  }

  /***
   * UI EFFECTS START HERE
   * UI EFFECTS START HERE
   * UI EFFECTS START HERE
   */

  commandScroll(dateId, scroll: ScrollLevel, idx = -1) {
    // console.log({ programEl: this.programEl, ossView: this.ossView })
    if (!this.programEl || !this.ossView) return;
    let k = 0;
    this.programEl.forEach(el => {
      if (
        el.nativeElement &&
        el.nativeElement.classList.contains(dateId)
      ) {
        const id_arr = el.nativeElement.id.split("-");
        const lane = this.ossView[id_arr[1]];
        if (!lane) return;
        if (k !== idx) {
          el.nativeElement.scrollTop =
            lane.ticks[scroll.tick].top -
            PROGRAM_TOP_SPACE +
            scroll.percentage * lane.ticks[scroll.tick].height;
        }
        this.currentTick = scroll.tick;
        this.scrollFlags[dateId + "_" + k++] = true;
      }
    });
  }

  private hoverProcess(sch) {
    const move$ = fromEvent(sch.nativeElement, "mousemove").pipe(
      debounceTime(10)
    );
    const leave$ = fromEvent(sch.nativeElement, "mouseleave");
    move$
      .pipe(
        takeUntil(leave$),
        repeat(),
        takeUntil(this.$destroy)
      )
      .subscribe((ev: MouseEvent) => this.mouseInBlock2(ev));
    leave$
      .pipe(takeUntil(this.$destroy))
      .subscribe(ev => this.mouseOutBlock(ev));
  }

  mouseScroll(ev, dateId, k) {
    if (this.dontAutoScroll)
      return;
    if (this.scrollFlags[dateId + "_" + k]) {
      this.scrollFlags[dateId + "_" + k] = false;
      return;
    }
    for (let i = 0; i < ev.target.children[0].children.length; i++) {
      const parent_el = ev.target.getBoundingClientRect();
      const rect = ev.target.children[0].children[
        i
      ].getBoundingClientRect();
      const level = parent_el.top + PROGRAM_TOP_SPACE;
      if (rect.top <= level && level < rect.bottom) {
        // console.log(parent_el.top, level, rect.top);
        this.currentTick = i;
        const percentage =
          (level - rect.top) / (rect.bottom - rect.top);
        this.scroll.tick = i;
        this.scroll.percentage = percentage;
        this.commandScroll(dateId, this.scroll, k);
        break;
      }
    }
  }

  mouseOutBlock(ev) {
    const indexes = (ev.target as Element).id.split("-");
    if (indexes.length !== 3 || this.readonly) {
      return;
    }

    const k = +indexes[2];

    const view = this.ossView[k];
    if (!view) return;
    // console.log('iew.controls, vs1, vs2', this.currentViewSet[1], this.currentViewSet[2]);
    if (
      this.currentViewSet.length &&
      view.controls[this.currentViewSet[1]]
    ) {
      view.controls[this.currentViewSet[1]][this.currentViewSet[2]] = 0;
    }
    this.currentViewSet = [];
    this.preset_time = "";
    view.shake = { row: -1, position: 1000000 };
    this.hoverMinute = null
  }

  mouseInBlock2(ev) {
    const indexes = (ev.target as Element).id.split("-");

    if (indexes.length !== 5 || this.readonly || this.currentEvent.closed) {
      return;
    }
    const k = +indexes[2]; // k is the index for a set of schedules and/or activities, aka view
    const i = +indexes[3]; // i is the schedule number, aka lane.  For standalones, it is 0, for others, it is the activity lane #
    const j = +indexes[4]; // j is the cell / hour, aka block, from 0-23, inclusive

    const view = this.ossView[k]; // the set of schedules and/or activities
    if (!view) return;

    const target = ev.target || ev.srcElement;
    const styl =
      target.currentStyle || window.getComputedStyle(target, null);
    const borderLeftWidth = parseInt(styl["borderLeftWidth"], 10);
    const borderTopWidth = parseInt(styl["borderTopWidth"], 10);
    const rect = target.getBoundingClientRect();
    const x = ev.clientX - borderLeftWidth - rect.left; // x is the x value within the cell (top left 0,0 coordinates)
    const y = ev.clientY - borderTopWidth - rect.top; // y is the y value within the cell
    if (5 < x && x < 395) {
      // leave a little bit of border where add an activity will not pop up

      // have moved cells OR lane is not standalone (view.lanes[this.currentViewSet[1]]) AND there are already activities in this

      let oldK, oldI, oldJ, old;
      if (this.currentViewSet.length) {
        old = true;
        oldK = this.currentViewSet[0];
        oldI = this.currentViewSet[1];
        oldJ = this.currentViewSet[2];
      }
      const enteredNewCell: boolean =
        !old || oldK !== k || oldI !== i || oldJ !== j;
      const oldCellAndIsNotStandaloneAndHasActivities =
        old &&
        !!view.lanes[oldI] &&
        !!view.lanes[oldI].blocks[oldJ].length; // view.lanes[oldI] is equivalent to view.lanes[oldI] !== 0

      // console.log({ new: enteredNewCell, oldWAct: oldCellAndIsNotStandaloneAndHasActivities })

      if (enteredNewCell || oldCellAndIsNotStandaloneAndHasActivities) {
        if (old && view.controls[oldI]) {
          view.controls[oldI][oldJ] = 0;
        }
        this.currentViewSet = [k, i, j]; // Index values for current mouse entered block
        const block = view.lanes[i] ? view.lanes[i].blocks[j] : [];
        if (block.length) {
          if (block[0].top >= y) {
            // console.log('block top >= y')
            view.controls[i][j] = 5;
            this.preset_time = ("0" + j).slice(-2) + ":00";
            // console.log({block0Top: block[0].top, less: block[0].top < STANDARD_ACTIVITY_HEIGHT + 5})
            if (block[0].top < STANDARD_ACTIVITY_HEIGHT + 5) {
              // if (block.some(b => b.top < STANDARD_ACTIVITY_HEIGHT + 5)) {
              view.shake = { row: j, position: 0 };
            } else {
              // make sure to unset view shake, since this means there is enough space for the add a new activity button without adding space.
              view.shake = { row: -1, position: 1000000 };
            }
          } else {
            let found = false;
            for (let idx = 0; idx < block.length - 1; idx++) {
              if (block[idx].top + STANDARD_ACTIVITY_HEIGHT - 5 < y && y <= block[idx + 1].top) {
                if (block[idx + 1].top - block[idx].top - STANDARD_ACTIVITY_HEIGHT < STANDARD_ACTIVITY_HEIGHT) {
                  view.shake = { row: j, position: block[idx].position };
                  // console.log('shake it')
                } else {
                  view.shake = { row: -1, position: 1000000 };
                  // console.log('don\'t shake it')
                }
                view.controls[i][j] =
                  block[idx].top + STANDARD_ACTIVITY_HEIGHT;
                this.preset_time = block[idx].time;
                // console.log(idx, y, block[idx + 1].top);
                found = true;
              }
            }
            if (!found && block[block.length - 1].top + STANDARD_ACTIVITY_HEIGHT - 5 < y) {
              view.shake = {
                row: j,
                position: block[block.length - 1].position
              };
              view.controls[i][j] =
                block[block.length - 1].top +
                STANDARD_ACTIVITY_HEIGHT;
              this.preset_time = block[block.length - 1].time;
            }
          }
        } else {
          view.shake = { row: -1, position: 1000000 };
          view.controls[i][j] = 5;
          this.preset_time = ("0" + j).slice(-2) + ":00";
        }
        if(!this.preset_time) this.preset_time = "00:00";  
        const timeParts = this.preset_time.split(":").map(numberText => parseInt(numberText))
        this.hoverMinute = timeParts[0]*60 + timeParts[1]
        this.hoverView = k
      }
    } else if (!ev.target.classList.contains("add_activity")) {
      view.shake = { row: -1, position: 1000000 };
    }
  }

}
